import apiOrgstructure from '@/api/orgstructure'

export default {
  companiesList({}, data) {
    return new Promise((resolve, reject) => {
      apiOrgstructure.companiesList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  updateCompany({}, data){
    return new Promise((resolve, reject) => {
      apiOrgstructure.updateCompany(data.id, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  deleteCompany({}, {id, hard}){
    if(hard){
      return new Promise((resolve, reject) => {
        apiOrgstructure.companyHardDelete(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        apiOrgstructure.deleteCompany(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  
  restoreCompany({}, id){
    return new Promise((resolve, reject) => {
      apiOrgstructure.restoreCompany(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  companyTree({}, id){
    return new Promise((resolve, reject) => {
      apiOrgstructure.companyTree(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  containersTree({}, {id, type}){
    return new Promise((resolve, reject) => {
      apiOrgstructure.containersTree(id, type).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  updateContainer({}, data){
    return new Promise((resolve, reject) => {
      apiOrgstructure.updateContainer(data.id, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  deleteContainer({}, {id, hard}){
    if(hard){
      return new Promise((resolve, reject) => {
        apiOrgstructure.containerHardDelete(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        apiOrgstructure.deleteContainer(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  
  restoreContainer({}, id){
    return new Promise((resolve, reject) => {
      apiOrgstructure.restoreContainer(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  updatePost({}, data){
    return new Promise((resolve, reject) => {
      apiOrgstructure.updatePost(data.id, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  deletePost({}, {id, hard}){
    if(hard){
      return new Promise((resolve, reject) => {
        apiOrgstructure.postHardDelete(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        apiOrgstructure.deletePost(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  
  restorePost({}, id){
    return new Promise((resolve, reject) => {
      apiOrgstructure.restorePost(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/store/orgstructure/actions.js